/* eslint-disable no-underscore-dangle */
import { removeAllChars, removeAllSpaces } from './remove'

const formatter = (value = '', prefix = '+90') => {
  let tempValue = `${value}`

  if (prefix) {
    tempValue = tempValue?.replace(prefix, '')
  }

  tempValue = removeAllChars(tempValue)

  if (!tempValue) return ''

  const matchArray = tempValue?.match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

  const _return = !matchArray[2]
    ? `${prefix || ''} ${matchArray[1]}`
    : `${prefix || ''} ${matchArray[1]} ${
      matchArray[2]
    }${matchArray[3] ? ` ${matchArray[3]}` : ''
    }${matchArray[4] ? ` ${matchArray[4]}` : ''}`

  return `${_return}`
}

/**
 * Display the canonical phone value exactly as stored by the backend.
 * Country codes belong to the value; callers must not prepend a fixed code.
 */
function display(value = '') {
  const normalizedValue = `${value || ''}`.trim()

  return normalizedValue || '-'
}

/**
 * Clearing mobileSuffix, space and nonDigit value
 * @param value a string will cleared
 * @param prefix prefix
 * @returns formatCleared
 */
function formatClear(value, prefix = '+90') {
  let tempValue = value
  if (tempValue) {
    tempValue = removeAllSpaces(removeAllChars(tempValue.replace(prefix, '')))
  }

  if (tempValue && tempValue.length > 10) {
    tempValue = tempValue.substring(0, 10)
  }

  return tempValue
}

/**
 * Checking phone number length is equal defaultPhoneNumberLength
 * @param value a string will checked
 * @returns true for valid false invalid
 */
function checker(value = '') {
  return formatClear(value).length === 10
}

/**
 * If value cannot get, checker returns isRequired. Checking phone number length is equal defaultPhoneNumberLength
 * @param value a string will checked
 * @param isRequired default is false
 * @returns true for valid false invalid
 */
function validityChecker(value = '', isRequired = false) {
  const _value = formatClear(value)

  if (_value) {
    return _value.length === 10
  }

  return !isRequired
}

/**
 * Generating for line "tel:.."
 * @param value a string will href
 * @param prefix default +90
 * @returns href string
 */
function generateHref(value = '', prefix = '+90') {
  if (!value) return undefined

  return `tel:${prefix || ''}${formatClear(value)}`
}

export default {
  checker,
  display,
  formatter,
  formatClear,
  validityChecker,
  generateHref,
}
